import React from 'react'
import { injectIntl } from 'react-intl'

import Button from '@uniiverse/library/components/button'

import { trackAmplitude } from 'src/lib/analytics'

import { TextInput } from '../text-input/index'
import { LocationInput } from '../location-input/index'

import locale from './locale'
import style from './index.css'

class SearchComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchQuery: props.searchQuery || '',
      locationQuery: props.locationQuery,
      page: props.page,
      sectionId: props.sectionId,
      lat: props.lat,
      lon: props.lon,
      resetFilters: false,
    }
  }

  componentDidMount() {
    trackAmplitude('Open Search', { ref: this.state.page, section: this.state.sectionId }, this.props.viewer)
    window.scrollTo(0, 0)
  }

  onSubmit = (e) => {
    e.preventDefault()
  }

  changeLocation = ({ lat, lon, locationQuery }) => {
    this.setState({ lat, lon, locationQuery })
  }

  search = () => {
    const { searchParams } = new URL(window.location)
    searchParams.set('query', encodeURIComponent(this.state.searchQuery))
    searchParams.set('loc', encodeURIComponent(this.state.locationQuery))
    searchParams.set('ll', encodeURIComponent(`${this.state.lat},${this.state.lon}`))

    if (this.state.resetFilters) {
      searchParams.delete('categories')
      searchParams.delete('time')
    }

    const url = `/explore?${searchParams.toString()}`
    this.props.history.push(url)
    this.props.closeSearch()
  }

  changeSearchQuery = (e) => {
    this.setState({ searchQuery: e.target.value })
  }

  changeLocationQuery = (locationQuery) => {
    this.setState({ locationQuery })
  }

  resetSearch() {
    return () => {
      this.setState({
        searchQuery: '',
        page: '',
        sectionId: '',
        locationQuery: SSR_DATA.cityName,
        lat: SSR_DATA.lat,
        lon: SSR_DATA.lon,
        resetFilters: true,
      })
    }
  }

  render() {
    const { closeSearch, intl } = this.props
    const { formatMessage } = intl

    return (
      <div className={style.container}>
        <div className={style.header}>
          <button className={style.close} onClick={closeSearch}>
            {formatMessage(locale.close)}
          </button>
          <div className={style.title}>
            {formatMessage(locale.title)}
          </div>
          <button className={style.reset} onClick={this.resetSearch()}>
            {formatMessage(locale.reset)}
          </button>
        </div>
        <div className={style.content}>
          <form action="#" onSubmit={this.onSubmit}>
            <div className={style.input}>
              <TextInput
                withClearIcon
                inputProps={{
                  onChange: this.changeSearchQuery,
                  value: this.state.searchQuery,
                  placeholder: formatMessage(locale.queryPlaceholder),
                  autoFocus: true,
                }}
              />
            </div>
            <div className={style.input}>
              <LocationInput
                value={this.state.locationQuery}
                onChange={this.changeLocationQuery}
                changeLocation={this.changeLocation}
                withClearIcon
              />
            </div>
            <div>
              <Button
                type="primary"
                className={style.button}
                onClick={this.search}
                disabled={!this.state.locationQuery}
              >
                {formatMessage(locale.action)}
              </Button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export const Search = injectIntl(SearchComponent)
